import { TimeSeriesDisableRange } from 'utils/timeseries/TimeSeriesDisableRange';
import { TimeSeriesDisableRangeLabel } from 'utils/timeseries/TimeSeriesDisableRange';
import { TimeLineLabel } from './timeline';

export const deriveTime = (d: TimeSeriesChartDataItem) => d.time;

export interface TimeSeriesChartDataItem {
    time: number;
}

export interface TimeSeriesChartData<T extends TimeSeriesChartDataItem> {
    dataSeries: T[];
    breaksInTrading: TimeSeriesDisableRange[];
    rangeLabels: TimeSeriesDisableRangeLabel[];
    timeLineLabels: TimeLineLabel[];
}
